module.exports = __webpack_public_path__ + "static/media/curious-toys.9f633dee.jpg";